<template>
  <b-tab :title="title" :active="active" :disabled="disabled">
    <template #title>
      <slot name="title"></slot>
    </template>
    <slot></slot>
  </b-tab>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      require
    },
    active: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>